import { Permission } from '../../../backend/src/auth/permissions/permission';

export interface PermissionInfo {
  permission: Permission;
  label: string;
  description: string;
}

export interface PermissionGroup {
  name: string;
  permissions: PermissionInfo[];
}

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    name: 'Matters',
    permissions: [
      {
        permission: Permission.MatterCreateUpload,
        label: 'Create Matters & Upload Documents',
        description: 'Create new matters and upload documents to Wexler',
      },
      {
        permission: Permission.MatterDeleteDocument,
        label: 'Delete Documents',
        description: 'Delete documents from matters',
      },

      {
        permission: Permission.MatterDelete,
        label: 'Delete Matters',
        description: 'Delete matters',
      },
      {
        permission: Permission.MatterAddUsers,
        label: 'Add Users to Matters',
        description: 'Add users to matters',
      },

      {
        permission: Permission.MatterViewAll,
        label: 'View All Matters',
        description: 'View all matters in the organisation, not just assigned ones',
      },
      {
        permission: Permission.MatterManageUsers,
        label: 'Manage Matter Memberships',
        description: 'Add and remove users from matters you are in',
      },
    ],
  },
  {
    name: 'User Management',
    permissions: [
      {
        permission: Permission.UsersManage,
        label: 'Manage Users',
        description: 'Create, edit, and delete user accounts and assign roles',
      },
    ],
  },
  {
    name: 'Integrations',
    permissions: [
      {
        permission: Permission.IntegrationsManage,
        label: 'Manage Integrations',
        description: 'Configure and manage external system integrations',
      },
      {
        permission: Permission.RelativityImport,
        label: 'Relativity Import',
        description: 'Import documents and data from Relativity',
      },
    ],
  },
  {
    name: 'Credit Limits',
    permissions: [
      {
        permission: Permission.TokenLimitsManage,
        label: 'Manage Credit Limits',
        description: 'Configure organisation and matter credit limits',
      },
    ],
  },
  {
    name: 'Analytics',
    permissions: [
      {
        permission: Permission.UsageDashboardView,
        label: 'View Usage Dashboard',
        description: 'Access organisation usage analytics and reports',
      },
      {
        permission: Permission.AuditViewAll,
        label: 'View audit trail',
        description: 'Access detailed audit trails of accessible matters',
      },
    ],
  },
  {
    name: 'Approval',
    permissions: [
      {
        permission: Permission.ApproveRuns,
        label: 'Approve Runs',
        description: 'Approve or reject case processing requiring additional approval',
      },
    ],
  },
  {
    name: 'Features',
    permissions: [
      {
        permission: Permission.RealtimeUse,
        label: 'Use Realtime Transcription',
        description: 'Access Wexler Real Time for live transcription & inconsistency detection',
      },
    ],
  },
];
